import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';
import message from 'src/components/message';
import QS from 'qs'
import { PATH_AUTH } from '../routes/paths';

// 不再需要导航函数设置，直接使用 window.location.href 进行401错误跳转

// 安全跳转函数 - 401错误时强制跳转，避免路由守卫干扰
const navigateToLogin = () => {
    console.log('401错误，强制跳转到登录页，避免路由守卫干扰');
    // 直接使用 window.location.href 确保跳转不被路由守卫拦截
    window.location.href = PATH_AUTH.login;
};
// ----------------------------------------------------------------------

const axiosInstance = axios.create({
    baseURL: HOST_API_KEY, //'/api',
    timeout: 120000
});
axiosInstance.interceptors.request.use(
    config => {
        console.log(config, '---config.url')
        // if(config.url?.includes('/auth/')){
        //   config.headers['X-JWT-AUD'] = 'backyard'
        // }
        // const token = store.state.token;        
        // token && (config.headers.Authorization = token);        
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)
axiosInstance.interceptors.response.use(
    response => {
        if (response.status >= 200 && response.status < 300) {
            console.log(response)
            // 检查业务状态码，可能的认证失败情况
            if (response.data && (response.data.code === 20 || response.data.code === 401 || response.data.code === 4001)) {
                const logoutInfo = {
                    reason: '业务层认证失败',
                    timestamp: new Date().toISOString(),
                    statusCode: response.data.code,
                    message: response.data.message,
                    url: response.config?.url,
                    currentPath: window.location.pathname
                };
                console.log('业务层认证失败，详情:', logoutInfo);
                localStorage.setItem('lastLogoutInfo', JSON.stringify(logoutInfo));

                localStorage.removeItem('accessToken');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('user');
                delete axiosInstance.defaults.headers.common.Authorization;

                alert('登录已过期，请重新登录');
                console.warn('🔄 业务层认证失败，强制跳转到登录页...');

                if (window.location.pathname !== PATH_AUTH.login) {
                    navigateToLogin();
                }
            }
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    }, error => {
        if (error.message.includes('timeout')) {
            message.error({ content: '网络超时' });
            return Promise.reject(error);
        }
        if (error.response && error.response.status) {
            switch (error.response.status) {
                case 400:
                    message.error({ content: error.response.data.message });
                    break;
                case 401:
                    // /auth/me 接口用于获取个人信息，如果401不一定是登录失效（可能是接口未配置等），不强制清除状态，交给业务处理
                    // if (error.config?.url && error.config.url.includes('/auth/me')) {
                    //     console.warn('⚠️ /auth/me 返回401，交给调用方处理，不强制登出');
                    //     break;
                    // }

                    // // 401错误表示token过期或无效，清除登录状态
                    // const logoutInfo401 = {
                    //     reason: 'HTTP 401 Unauthorized',
                    //     timestamp: new Date().toISOString(),
                    //     url: error.config?.url,
                    //     method: error.config?.method,
                    //     currentPath: window.location.pathname,
                    //     errorMessage: error.response?.data?.message || error.message
                    // };
                    // console.log('401错误，token可能已过期', logoutInfo401);
                    // localStorage.setItem('lastLogoutInfo', JSON.stringify(logoutInfo401));

                    // localStorage.removeItem('accessToken');
                    // localStorage.removeItem('refresh_token');
                    // localStorage.removeItem('user');
                    // delete axiosInstance.defaults.headers.common.Authorization;

                    // console.warn('🔄 检测到401错误，跳转登录页...');
                    // // 不显示错误消息，直接跳转登录页
                    // if (window.location.pathname !== PATH_AUTH.login) {
                    //     navigateToLogin();
                    // }
                    break;
                case 404:
                    // /auth/me 返回 404 视为登录态失效，执行登出
                    if (error.config?.url && error.config.url.includes('/auth/me')) {
                        console.warn('⚠️ /auth/me 返回404，token 已过期，强制登出');
                        localStorage.removeItem('accessToken');
                        localStorage.removeItem('refresh_token');
                        localStorage.removeItem('user');
                        delete axiosInstance.defaults.headers.common.Authorization;
                        if (window.location.pathname !== PATH_AUTH.login) {
                            navigateToLogin();
                        }
                        break;
                    }
                    message.error({ content: '404,网络请求不存在' });
                    break;
                case 500:
                    message.error({ content: '500,服务器端错误' });
                    break;
                //其他错误，直接抛出错误提示
                default:
                //   message.error((error.response.data && error.response.data.message) || "Error")
            }
            return Promise.reject(error.response);
        }
    }
);

let timer = new Date().getTime().toString();
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function GET(url: string, params: object) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(url + `?t=${timer}`, { //随机数 针对IE设置
            params: params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function POST(url: string, params: object) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(url, QS.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}


export function POST_JSON(url: string, params: object) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * post方法，对应post请求, form-data
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function FILE(url: string, params: FormData | object) {
    let formData: FormData;

    // 如果传入的已经是FormData对象，直接使用
    if (params instanceof FormData) {
        formData = params;
    } else {
        // 否则将普通对象转换为FormData
        formData = new FormData();
        for (var key in params) {
            // @ts-ignore
            formData.append(key, params[key])
        }
    }

    return new Promise((resolve, reject) => {
        axiosInstance.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function PUT(url: string, params: object) {
    return new Promise((resolve, reject) => {
        axiosInstance.put(url, QS.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * put方法，发送JSON数据
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function PUT_JSON(url: string, params: object) {
    return new Promise((resolve, reject) => {
        axiosInstance.put(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}

export function PATCH_JSON(url: string, params: object) {
    return new Promise((resolve, reject) => {
        axiosInstance.patch(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}

export function DELETE(url: string, params: object) {
    return new Promise((resolve, reject) => {
        axiosInstance.delete(url, { params: params })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}
export default axiosInstance;
